<template>
  <v-dialog v-model="dialog" persistent max-width="440px">
    <v-card v-if="customer">
      <v-card-title>
        <app-title> Rejeitar cadastro </app-title>
      </v-card-title>
      <v-card-text>
        Tem certeza que quer rejeitar o cadastro de
        <strong>{{ customer.name }}</strong>? Ele será excluído e não poderá
        ser recuperado.
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <app-btn color="error" @click="handleReject()"> Rejeitar </app-btn>
        <app-btn outlined rounded @click="dialog = false" text> voltar </app-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    customer: null,
  }),

  methods: {
    open(customer) {
      this.customer = customer;
      this.dialog = true;
    },

    async handleReject() {
      this.$loading.start();
      await this.$http
        .update("customer/customer-self-registration", this.customer.id, {
          status: "rejected",
        })
        .then(() => {
          this.$loading.finish();
          this.$emit("reject");
          this.dialog = false;
        })
        .catch(() => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>
